import React from 'react';
import PropTypes from 'prop-types';
import ClickLink from 'App/components/styles/ClickLink';

const AssessmentSidebarEngagementSubscribed = ({ showMessagingModal, showHistoryModal, showUnenrollmentModal }) => (
    <>
        <div style={{ width: '100%' }}>
            <i className="fas fa-fw fa-check text-success" />
            <span>
                Patient Messaging: <span id="engage-patient-messaging-enrollment-status">Enrolled</span>
            </span>
        </div>
        <div style={{ width: '100%', marginTop: 4, display: 'flex', gap: 12, flexWrap: 'wrap' }}>
            <ClickLink onClick={showMessagingModal}>Edit</ClickLink>
            {' | '}
            <ClickLink onClick={showUnenrollmentModal}>Unenroll</ClickLink>
            {' | '}
            <ClickLink onClick={showHistoryModal}>
                <i className="fa fa-fw fa-history" id="view-engage-patient-messaging-history-link" /> View History
            </ClickLink>
        </div>
    </>
);

AssessmentSidebarEngagementSubscribed.propTypes = {
    showMessagingModal: PropTypes.func.isRequired,
    showHistoryModal: PropTypes.func.isRequired,
    showUnenrollmentModal: PropTypes.func.isRequired,
};

export default AssessmentSidebarEngagementSubscribed;
